import http from './ajax';

const API_URL = {
  contactUrl: '/ContactUs/Send',
};

class ContactApi extends http {
  // eslint-disable-next-line no-unused-vars
  postContact = async (params = {}) => {
    const url = `${API_URL.contactUrl}`;
    try {
      const response = await this.postRequest(url, params);
      return response;
    } catch (err) {
      return err;
    }
  }
}

export default new ContactApi();
